


















































































import Vue from 'vue';
import Cleave from 'cleave.js';
import Datepicker from 'vuejs-datepicker';
//import { isValid, format, parse, isBefore, isAfter, subHours, subMinutes, set } from 'date-fns';
import moment from 'moment-timezone';
import { parseDate, rezoneToRome, romeToLocal, format, isValid } from './utils';

export default Vue.extend({
  components: {
    'datepicker': Datepicker,
  },
  directives: { 
    cleave: {
      bind: function (el: any, binding: any) {
        el._vCleave = new Cleave(el, binding.value); 
      },
      unbind: function (el: any) {
        el._vCleave.destroy();
      }
    }
  },
  props: {
    value: Date,
    useLocale: {
      type: Boolean,
      default: false,
    },
    showCalendar: {
      type: Boolean,
      default: true,
    },
    dateFormat: {
      type: String,
      required: true
    },
    inputName: {
      type: String,
      default: 'date'
    },
    inputId: String,
    labelClass: [Object, String, Function, Array],
    dateMin: Date,
    dateMax: Date,
    inputClass: [Object, String, Function, Array],
    inputLabel: String,
    inputHelpBlockClass: [Object, String, Function, Array],
    inputHelpBlock: String,
    inputPlaceholder: String,
    delimiter: {
      type: String,
      required: true
    },
    dpname: String,
    dpid: String,
    dpformat: {
      type: [String, Function],
    },
    dplanguage: Object,
    dpopenDate: [Date, String],
    dpdayCellContent: Function,
    dpfullMonthName: Boolean,
    dpdisabledDates: Object,
    dphighlighted: Object,
    dpplaceholder: String,
    dpinline: Boolean,
    dpcalendarClass: [String, Object, Array],
    dpinputClass: [String, Object, Array],
    dpwrapperClass: [String, Object, Array],
    dpmondayFirst: Boolean,
    dpclearButton: Boolean,
    dpclearButtonIcon: String,
    dpcalendarButton: Boolean,
    dpcalendarButtonIcon: String,
    dpcalendarButtonIconContent: String,
    dpbootstrapStyling: Boolean,
    dpinitialView: String,
    disabled: Boolean,
    required: Boolean,
    dptypeable: {
      type: Boolean,
      default: true
    },
    dpuseUtc: Boolean,
    dpminimumView: String,
    dpmaximumView: String,
    autofix: {
      type: Boolean,
      default: false,
    },
    time: {
      type: String,
    }
  },
  data: function() {
    return {
      timeHours: 0,
      timeMinutes: 0,
      date: null as null|Date,
      dateInput: '' as string,
      internalDate: null as null|Date,
    };
  },
  mounted: function() {
    if (this.time) {
      const timearr = this.time.split(':');
      if (timearr.length < 2) {
        this.handleTimeSettingFormatError();
      }
      this.timeHours = parseInt(timearr[0]);
      this.timeMinutes = parseInt(timearr[1]);
      if ((this.timeHours > 59 || this.timeHours < 0) || (this.timeMinutes > 59 || this.timeMinutes < 0)) {
        this.handleTimeSettingFormatError();
      }
    }
    if (this.value) {
      // all incoming date values have to be already "rezoned". Init the inputs and the internal value.
      // We can't use the "value" prop since that should not be mutated.
      this.date = this.useLocale ? (this.value as unknown as Date) : romeToLocal(this.value as unknown as Date);
      this.dateInput = this.useLocale ? this.format((this.value as unknown as Date), this.dateFormat) : this.format(romeToLocal(this.value as unknown as Date), this.dateFormat);
      this.internalDate = moment(this.value).clone().toDate();
    }
    const that = this as any;
    that.$refs.dpicker.$el.querySelector('input').style.display = 'none';
  },
  methods: {
    format,
    handleTimeSettingFormatError() {
      throw new Error('Invalid time format. Allowed string format: xx:xx');
    },
    handlePickerInput(val: any) {
      if (val === null) {
        // this condition can be triggered when the dpclearButton is set true
        // and the user clicks on the clear button
        this.date = val;
        this.dateInput = val;
      } else {

        this.internalDate = this.useLocale ? moment(val).hours(this.timeHours).minutes(this.timeMinutes).toDate() : rezoneToRome(val, this.timeHours, this.timeMinutes);

        if (this.autofix) {
          this.internalDate = this.checkMinMax(this.internalDate);
        }

        this.date = new Date(val);
        this.dateInput = format(this.date, this.dateFormat);
      }
      this.date && this.emitNewDateInput(this.internalDate)
      this.$emit('dpinput', this.internalDate);
    },
    handleClick() {
      const that = this as any;
      if (this.showCalendar) {
        this.$emit('dpopened');
        that.$refs.dpicker.showCalendar();
      }
    },
    handleBlur() {
      if (this.dateInput) {
        this.internalDate = parseDate(this.dateInput, this.dateFormat);
        this.internalDate = this.useLocale ? moment(this.internalDate).hours(this.timeHours).minutes(this.timeMinutes).toDate() : rezoneToRome(this.internalDate, this.timeHours, this.timeMinutes);
        if (this.autofix) {
          this.internalDate = this.checkMinMax(this.internalDate);
          this.dateInput = this.useLocale ? this.format(this.internalDate, this.dateFormat) : this.format(romeToLocal(this.internalDate), this.dateFormat);
        }
      }

      const that = this as any;
      that.$refs.dpicker && that.$refs.dpicker.close();
      this.emitNewDateInput(this.internalDate)
    },
    handleCleaveChange(e: any) {
      if (!e || !e.target) {
        return;
      }
      
      if (e.target.value.length > 0) {
        this.internalDate = parseDate(e.target.value, this.dateFormat);
        if (!isValid(this.internalDate) || !(e.target.value.length === this.dateFormat.length)) {
          this.internalDate = null;
          return;
        }

        //if (!this.useLocale) {
        this.internalDate = this.useLocale ? moment(this.internalDate).hours(this.timeHours).minutes(this.timeMinutes).toDate() : rezoneToRome(this.internalDate, this.timeHours, this.timeMinutes);
        //}

        this.dateInput = e.target.value;
        this.date = this.useLocale ? this.internalDate : romeToLocal(this.internalDate as unknown as Date);
      } else {
        this.internalDate = null;
        this.date = null;
        this.dateInput = '';
      }

      this.emitNewDateInput(this.internalDate);
    },
    checkMinMax(val: any): Date {
      const minDate = this.compDateMin ? new Date(this.compDateMin) : null;
      const maxDate = this.compDateMax ? new Date(this.compDateMax) : null;
      if (minDate && moment(val).isBefore(minDate)) {
        val = minDate;
      }
      if (maxDate && moment(val).isAfter(maxDate)) {
        val = maxDate;
      }
      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach((range: any) => {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (moment(val).isBefore(range.to) && moment(val).isAfter(range.from)) {
              val = moment(val).date(range.from.getDate()).add(-1, 'd').toDate();
            }
          }
        })
      }

      return val;
    },
    emitNewDateInput(val: Date|null) {
      //this.$emit('input', (val && this.time) ? set(val, {hours: this.timeHours, minutes: this.timeMinutes}) : val);
      this.$emit('input', val);
    }
  },
  computed: {
    compDateMin(): string|null {
      if (!this.dateMin || !this.autofix) {
        return null
      }
      const val = this.format(this.dateMin as unknown as Date, 'YYYY-MM-DD');
      return val;
    },
    compDateMax(): string|null {
      if (!this.dateMax || !this.autofix) {
        return null;
      }
      const val = this.format(this.dateMax as unknown as Date, 'YYYY-MM-DD');
      return val;
    },
    datePattern(): string[] {
      return this.dateFormat.split(this.delimiter).map((val: string) => {
        let res = val;
        switch(val[0]) {
          case 'M':
            res = 'm';
            break;
          case 'D':
            res = 'd';
            break;
          case 'y':
            res = 'Y'
            break;
        }
        return res[0];
      });
    },
    disabledDates(): any {
      const disabledDates = {...this.dpdisabledDates} || {};
      if (this.dateMin && !disabledDates.to) {
        disabledDates.to = romeToLocal(this.dateMin as unknown as Date);
      }
      if (this.dateMax && !disabledDates.from) {
        disabledDates.from = romeToLocal(this.dateMax as unknown as Date);
      }

      return disabledDates;
    }
  },
  watch: {
    value: function(newVal: Date|null) {
      if (newVal) {
        this.internalDate = new Date(this.value) as unknown as Date;

        this.date = this.useLocale ? this.internalDate : romeToLocal(this.internalDate);
        this.dateInput = this.useLocale ? this.format(this.internalDate, this.dateFormat) : this.format(romeToLocal(this.internalDate), this.dateFormat);
      } else {
        this.internalDate = null;
        this.date = null;
        this.dateInput = '';
      }
    }
  }
});
